import React, { useState, useEffect } from 'react'
import ResponseMsg from '../general/ResponseMsg';
import extraImg from '../assets/empty-cart.gif';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Loading from '../general/Loading';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ManageOrders = () => {
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  const [showUpdate, setShowUpdate] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [response, setResponse] = useState(null);
  const [showInvoice, setShowInvoice] = useState(false);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assignedOrder, setAssignedOrder] = useState([]);
  const [assignedExcOrder, setAssignedExcOrder] = useState([]);
  const [showDelivery, setShowDelivery] = useState(false);
  const [showExcDelivery, setShowExcDelivery] = useState(false);
  const [orderAddress, setOrderAddress] = useState('');
  const [exchange, setExchange] = useState([]);
const [showExchangeUpdate, setShowExchangeUpdate] = useState(false);
const [selectedExchange, setSelectedExchange] = useState(null);
const [exchangeStatus, setExchangeStatus] = useState('');
const [exchangeRemark, setExchangeRemark] = useState('');

// store allotment
const [store, setStore] = useState([]);
const [showStore, setShowStore] = useState(false);


const getToday = () => { const today = new Date(); return today.toISOString().split("T")[0]; }; const getPast7Days = () => { const past = new Date(); past.setDate(past.getDate() - 7); return past.toISOString().split("T")[0]; }; const [startDate, setStartDate] = useState(getPast7Days()); const [endDate, setEndDate] = useState(getToday());

    const fetchOrders = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-orders`);
        setLoading(false);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          console.log(sortedProducts);
          setOrders(sortedProducts);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching products:', error);
      }
    };

        const fetchExchange = async () => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-exchange-order`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          setExchange(sortedProducts);
          console.log(exchange);
        } else {
          console.error('Failed to fetch exchange');
        }
      } catch (error) {
        console.error('Error fetching exchange:', error);
      }
    };

        const fetchDeliveryAgent = async () => {
      setLoading(true);

      try {
        const response = await fetch('https://api.kcmstore.in/store/get-delivery-agent');
        if (response.ok) {
          const data = await response.json();
          setLoading(false);
          setStaff(data);
        } else {
          console.error('Failed to fetch staff members');
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching staff:', error);
        setLoading(false);
      }
    };


        const fetchAssignedOrder = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-assigned-order');
        if (response.ok) {
          const data = await response.json();
          setAssignedOrder(data);
          console.log(data);
        } else {
          console.error('Failed to fetch staff members');
        }
      } catch (error) {
        console.error('Error fetching staff:', error);
      }
    };

        const fetchAssignedExcOrder = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-exchange-assigned-order');
        if (response.ok) {
          const data = await response.json();
          setAssignedExcOrder(data);
        } else {
          console.error('Failed to fetch staff members');
        }
      } catch (error) {
        console.error('Error fetching staff:', error);
      }
    };


        const fetchStaff = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-staff');

        setLoading(false);
        if (response.ok) {
          const data = await response.json();
          setStore(data);
        } else {
          setLoading(false);
          console.error('Failed to fetch staff members');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching staff:', error);
      }
    };

  useEffect(() => {


    fetchExchange();
    fetchOrders();
    fetchDeliveryAgent();
    fetchAssignedOrder();
    fetchAssignedExcOrder();
    fetchStaff();
  }, []);

  

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };


const filteredOrders = orders.filter(order => {
  const orderItems = JSON.parse(order.order_items);

  const orderDate = new Date(order.order_date);
  const start = new Date(startDate);
  const end = new Date(endDate);
  end.setHours(23,59,59,999);

  const isWithinDateRange = orderDate >= start && orderDate <= end;

  const isStatusMatch = order.order_status.toLowerCase().includes(searchQuery.toLowerCase());
  const isUserMatch = order.user_name.toLowerCase().includes(searchQuery.toLowerCase());
  const isProductNameMatch = orderItems.some(orderItem =>
    orderItem.product_name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const isOrderIdMatch = order.id.toString().includes(searchQuery.toLowerCase());

  return isWithinDateRange && (isOrderIdMatch || isProductNameMatch || isUserMatch || isStatusMatch);
});


  const handleUpdateDialog = (order) => {
    setSelectedProduct(order);
    setShowUpdate(true);
  }

  const handleUpdateStatus = async (orderId, user_id, status) => {
    setLoading(true);
    console.log(selectedProduct);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/update-order-status/${orderId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          status: status,
          user_id: user_id
        }),
      });

      setLoading(false);
      if (response.ok) {
        const updatedOrder = await response.json();
        setOrders(prevOrders =>
          prevOrders.map(order =>
            order.id === orderId ? { ...order, order_status: status } : order
          )
        );
        setShowUpdate(false);
        setResponse('Order status updated successfully.');
        setTimeout(() => {
          setResponse('');
        }, 2000)
      } else {
        setLoading(false);
        setResponse('Failed to update order status');
        setTimeout(() => {
          setResponse('');
        }, 2000)
      }
    } catch (error) {
      setLoading(false);
      console.error('Error updating order status:', error);
    }
  };

  const handleShowInvoice = (order) => {
    setSelectedProduct(order);
    setShowInvoice(true);
  }

  const handlePrint = () => {
    setTimeout(() => {
      window.print();
    }, 200);
  };


  const handleDeliveryDialog = (order) => {
    setSelectedProduct(order);
    setShowDelivery(true);
  }


    const handleExcDeliveryDialog = (exc) => {
    setSelectedProduct(exc);
    setShowExcDelivery(true);
  }


  const handleAssignStatus = async (orderId, userId, staffId) => {
    setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/assign-order-delivery/${staffId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          orderId: orderId,
          user_id: userId,
        }),
      });

      setLoading(false);
      if (response.ok) {
        setShowDelivery(false);
        setResponse('Order Assigned successfully.');
         setOrders(prevOrders =>
          prevOrders.map(order =>
            order.id === orderId ? { ...order, order_status: 'Assigned Delivery Partner' } : order
          )
        );
        fetchAssignedOrder();

      } else {
        setResponse('Failed to assign order');
        setLoading(false);
        setTimeout(() => {
          setResponse('');
        }, 2000)
      }
    } catch (error) {
      setLoading(false);
      console.error('Error assigning order:', error);
    }
  };


    const handleAssignStore = async (orderId, remark, subId) => {
    if (!remark || !subId) {
    setResponse("Invalid Remark or Sub Store.");
 setTimeout(() => {
          setResponse('');
        }, 2000)
            return;
  }

    setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/allot-order-store/${subId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          orderId: orderId,
          remark: remark,
        }),
      });

      setLoading(false);
      if (response.ok) {
        setShowStore(false);
        setResponse('Order alloted to Store.');
 setTimeout(() => {
          setResponse('');
        }, 2000)
        fetchOrders();
        // fetchAssignedOrder();

      } else {
        setResponse('Failed to allot order');
        setLoading(false);
        setTimeout(() => {
          setResponse('');
        }, 2000)
      }
    } catch (error) {
      setLoading(false);
      console.error('Error assigning order:', error);
    }
  };

    const handleExcAssignStatus = async (excId, user_id, staffId) => {
    setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/assign-exchange-order-delivery/${staffId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          excId: excId,
          user_id: user_id
        }),
      });

      setLoading(false);
      if (response.ok) {
        setShowExcDelivery(false);
        setResponse('Exchange Order Assigned successfully.');
        setTimeout(() => {
          setResponse('');
        }, 2000)
        fetchAssignedExcOrder();
      } else {
        setResponse('Failed to assign order');
        setLoading(false);
        setTimeout(() => {
          setResponse('');
        }, 2000)
      }
    } catch (error) {
      setLoading(false);
      console.error('Error assigning order:', error);
    }
  };

    const getOrderLocation = async (lat, lon) => {
      try {
          const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`);
          const data = await response.json();
  
          return data.display_name || 'Unknown location';
      } catch (error) {
          console.error('Error fetching order address:', error);
          return 'Failed to fetch location';
      }
  };
  
    useEffect(() => {
      const fetchOrderAddress = async () => {
          if (selectedProduct?.lat && selectedProduct?.longi) {
              const address = await getOrderLocation(selectedProduct.lat, selectedProduct.longi);
              setOrderAddress(address);
          } else {
              setOrderAddress(`${selectedProduct.user_location || selectedProduct.user_address}, ${selectedProduct.user_city}, ${selectedProduct.user_state}, ${selectedProduct.user_pincode}`);
          }
      };
  
      fetchOrderAddress();
  }, [selectedProduct]);
  

const handleExchangeUpdate = async () => {
  if (!exchangeStatus) {
    alert('Please select a status.');
    return;
  }
  if (exchangeStatus == 'Cancelled' && exchangeRemark == '') {
    alert('Please enter remark');
    return;
  }


  setLoading(true);
  try {
    const response = await fetch(`https://api.kcmstore.in/store/exchange-update/${selectedExchange.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        req_status: exchangeStatus,
        remark: exchangeRemark,
        user_id: selectedExchange.user_id
      })
    });

    if (response.ok) {
        setResponse('Exchange status updated successfully.');
        setLoading(false);
        setTimeout(() => {
          setResponse('');
        }, 2000);
              setShowExchangeUpdate(false);

      const updatedExchange = exchange.map(ex =>
        ex.id === selectedExchange.id
          ? { ...ex, req_status: exchangeStatus, remark: exchangeRemark }
          : ex
      );
      setExchange(updatedExchange);
    } else {
        setResponse('Something went wrong');
        setLoading(false);
        setTimeout(() => {
          setResponse('');
        }, 2000)
    }
  } catch (error) {
  setLoading(false);
    console.error('Error updating exchange status:', error);
  }
};


const today = new Date().toISOString().split("T")[0];

const todaysSale = orders
  .filter(order => order.order_date.startsWith(today))
  .reduce((sum, order) => sum + Number(order.total_amount), 0);

const totalSale = filteredOrders
  .reduce((sum, order) => sum + Number(order.total_amount), 0);


  const downloadExcel = () => {
  const data = filteredOrders.map(order => {
let itemsText = '';     try {
       const items = JSON.parse(order.order_items);

      itemsText = items.map(item =>
        `${item.product_name} (Qty: ${item.quantity})`
      ).join(', ');
    } catch (e) {
      itemsText = 'Invalid items data';
    } 

return {
    Order_ID: order.id,
    Date: formatDate(order.order_date),
    Customer: order.user_name,
    Phone: order.user_phone,
    // Address: orderAddress,
        Amount: order.total_amount,
    Store: order.sub_admin_name,
    Store_Phone: order.sub_admin_phone,
    Alloted_on: formatDate(order.alloted_on),
    Store_Rem: order.remark,
    Status: order.order_status,
    Items: itemsText
  }});

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream"
  });

  saveAs(blob, "orders_report.xlsx");
};

  return (
    <>
      <section className='py-4 bg-light'>
        <div className='px-3'>

          <div className='d-flex'>
            <p className='sec-heading'>Orders History</p>
            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Manage</span>
          </div>


<div className="row">
  {/* Today's Sale */}
  <div className="col-md-4 mb-3">
    <div className="bg-white p-3 rounded shadow-sm text-center">
      <h6 className="text-muted">Today's Sale</h6>
      <h4 className="fw-bold text-success">₹ {todaysSale.toFixed(2)}</h4>
    </div>
  </div>

  {/* Total Sale */}
  <div className="col-md-4 mb-3">
    <div className="bg-white p-3 rounded shadow-sm text-center">
      <h6 className="text-muted">Total Sale</h6>
      <h4 className="fw-bold text-primary">₹ {totalSale.toFixed(2)}</h4>
    </div>
  </div>

  {/* Download Report */}
  <div className="col-md-4 mb-3">
    <div className="bg-white p-3 rounded shadow-sm text-center">
      <h6 className="text-muted">Sale Report</h6>
      <button className="btn btn-success w-auto para-text" onClick={downloadExcel}>
        Excel Download 📊
      </button>
    </div>
  </div>
</div>


<div className="row">
            <div className="text-start col-md-6 mb-3">
            <input
              type="text"
              className="form-input rounded border-0"
              placeholder="🎯 Search order here..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

     <div className='col-md-3 col-sm-6 mb-2' >   
  <input
    type="date"
    className="form-input"
    value={startDate}
    onChange={(e) => setStartDate(e.target.value)}
    max={endDate}
  />
</div> 

     <div className='col-md-3 col-sm-6 mb-2' >
  <input
    type="date"
    className="form-input"
    value={endDate}
    onChange={(e) => setEndDate(e.target.value)}
    min={startDate}
  />
</div>
</div>


          <div className='bg-white px-3 py-3 rounded-4'>

            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => {
                const orderItems = JSON.parse(order.order_items);
                return (
                  <div className='my-3' key={order.id}>
                    <div className='order-area'>

                      {order.order_status == 'Confirmed' &&
                      <div className='text-end'>
                                          <span className='badge bg-danger'>New</span></div>}
                                          
                      <p className='fw-semibold my-0'>#{order.id} placed on {formatDate(order.order_date)}</p>
                      <p className='text-muted fw-semibold para-text'>Customer Name: {order.user_name}<br />
                      {order.allot_id != null && (
                        <span>{order.sub_admin_name} Store ({order.sub_admin_phone}) Alloted on {formatDate(order.alloted_on)} {order.remark != null && (<><br />Store Remark: {order.remark}</>)}</span>
                      )}
                      </p>



                      {order.order_status !== 'Cancelled' && (() => {
  const existingExchange = exchange.find(ex => ex.order_id == order.id);

  if (existingExchange) {
    return (
      <div className='text-end'>
      <button className='bg-success text-light para-text fw-semibold order-btn px-2 py-1'
onClick={() => {
    setSelectedExchange(existingExchange);
    setExchangeStatus(existingExchange.req_status || '');
    setExchangeRemark(existingExchange.remark || '');
    setShowExchangeUpdate(true);
    console.log(selectedExchange);
  }}  >
        Exchange Request | Status: {existingExchange.req_status}
      </button>
                            {(() => {
  const assignedAgent = assignedExcOrder.find(item => item.exc_id == existingExchange.id);

  return (
    <>
      {assignedAgent ? (
        <p className='fw-semibold para-text text-muted'>
          Delivery Agent: {assignedAgent.delivery_agent_name}<br />
          Agent Contact: {assignedAgent.delivery_agent_phone}
        </p>
      ) : (
''      )}
    </>
  );
})()}
      </div>
    );
  }
})()}
                      <Swiper spaceBetween={20} slidesPerView={8} modules={[Navigation, Autoplay]} loop={true}
                      autoplay={{
    delay: 2000,
  }}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        breakpoints={{
                          0: {
                            slidesPerView: 3,
                          },
                          768: {
                            slidesPerView: 5,
                          },
                          992: {
                            slidesPerView: 8,
                          }
                        }}>

                        {orderItems.length > 0 ? (
                          orderItems.map((item, index) => (
                            <>
                              <hr />
                              <SwiperSlide key={index} className='my-2'>
                                <img
                                  src={`https://api.kcmstore.in/sUploads/${item.image.split(',')[0]}`}
                                  className='img-fluid'
                                  alt='Order'
                                />
                                <p className='mb-0 fw-semibold' style={{fontSize: '0.8em'}}>{item.product_name} | Qty: {item.quantity}</p>
                              </SwiperSlide>
                            </>
                          ))
                        ) : (
                          <p>No items in this order</p>
                        )}
                      </Swiper>
                      {/* <p className='mt-3 text-muted fw-semibold para-text'>Payment Mode: {order.payment_mode}<br />Payment Id: {order.payment_id || 'NA'}<br />Payment Status: {order.payment_status}</p> */}
                      <p className='text-muted fw-semibold mt-2 para-text'>Order Total ₹ {order.total_amount}<br />This Order has been {order.order_status}</p>

                      {(() => {
  const assignedAgent = assignedOrder.find(item => item.order_id === order.id);

  return (
    <>
      <hr />
      {assignedAgent ? (
        <p className='fw-semibold para-text text-muted'>
          Delivery Agent: {assignedAgent.delivery_agent_name}<br />
          Agent Contact: {assignedAgent.delivery_agent_phone}
        </p>
      ) : (
        <p className='fw-semibold para-text text-muted'>No Delivery Agent Assigned yet</p>
      )}
    </>
  );
})()}

                      <div className='d-md-flex mt-3'>
                        <button className='order-btn mx-1 my-1 w-100' onClick={() => handleShowInvoice(order)}>Order Invoice 📃</button>

                        {order.order_status != 'Delivered' && order.allot_id == null &&
                         <button className="order-btn mx-1 my-1 w-100" onClick={() => {setSelectedProduct(order); setShowStore(true)}}>
                              Allot Store <i className="fa-solid fa-store"></i>
                            </button>
              }
                        {order.order_status === 'Cancelled' ? '' :

                          <>
                          {order.order_status != 'Delivered' && order.order_status != 'Assigned Delivery Partner' &&
                          <>
                                                      <button className="order-btn mx-1 my-1 w-100" onClick={() => handleUpdateDialog(order)}>
                              Update Order Status ✔
                            </button>
                            
                            </>
}

                            {!(order.order_status === 'Assigned Delivery Partner' || order.order_status === 'Out for Delivery' || order.order_status === 'Delivered') ? (
                              <button className="order-btn mx-1 my-1 w-100" onClick={() => handleDeliveryDialog(order)}>
                                Assign Delivery Agent 🚛
                              </button>
                            ) : null}
                          </>

                        }

                                              {order.order_status == 'Delivered' && (() => {
  const existingExchange = exchange.find(ex => ex.order_id == order.id);

  if (existingExchange && (existingExchange.req_status != 'Assigned Delivery Partner' && existingExchange.req_status != 'Delivered')) {
    return (
                              <button className="order-btn mx-1 my-1 w-100" onClick={() => handleExcDeliveryDialog(existingExchange)}>
                                Assign Exchange Agent 🚛
                              </button>

    );
  }
})()}
                      </div>
                    </div>
                  </div>
                );

              })
            ) : (
              <div className='text-center'>
                <img src={extraImg} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                <p>No Orders Placed yet</p>
              </div>
            )}

          </div>
          {/* row ends */}

        </div>
      </section>


      {showUpdate && (
        <>
          <section className='delete-dialog px-3' onClick={() => setShowUpdate(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category my-4'>Update Order Status</p>

              <select
                id="order-status"
                className="form-select mb-4"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}>
                <option value="">Select status</option>
                <option value="Dispatched">Dispatched</option>
                <option value="Shipped">Shipped</option>
                {/* <option value="Out for Delivery">Out for Delivery</option> */}
              </select>

              <button className='success-btn' onClick={() => handleUpdateStatus(selectedProduct.id, selectedProduct.user_id, newStatus)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowUpdate(false)}>No</button>
            </div>
          </section>
        </>
      )}


      {showDelivery && (
        <>
          <section className='delete-dialog px-3'>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-4 rounded-4'>
              <p className='featured-category my-4'>Assign Order Delivery</p>

              <select
                id="order-status"
                className="form-select mb-4"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}>
                <option value="">Select Agent</option>
                {loading ? (
                  <option>Loading...</option>
                ) : (
                  // Map over the unique categories
                  staff.map((staff, index) => (
                    <option key={index} value={staff.id}>
                      {staff.name}
                    </option>
                  ))
                )}
              </select>

              <button className='success-btn' onClick={() => handleAssignStatus(selectedProduct.id, selectedProduct.user_id, newStatus)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowDelivery(false)}>No</button>
            </div>
          </section>
        </>
      )}


      {showExcDelivery && (
        <>
          <section className='delete-dialog px-3'>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-4 rounded-4'>
              <p className='featured-category my-4'>Assign Exchange Order Delivery</p>

              <select
                id="order-status"
                className="form-select mb-4"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}>
                <option value="">Select Agent</option>
                {loading ? (
                  <option>Loading...</option>
                ) : (
                  // Map over the unique categories
                  staff.map((staff, index) => (
                    <option key={index} value={staff.id}>
                      {staff.name}
                    </option>
                  ))
                )}
              </select>

              <button className='success-btn' onClick={() => handleExcAssignStatus(selectedProduct.id, selectedProduct.user_id, newStatus)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowExcDelivery(false)}>No</button>
            </div>
          </section>
        </>
      )}

      {response && <ResponseMsg message={response} />}

      {showInvoice && selectedProduct && orderAddress && (
        <>
          <section className='invoice-dialog px-2' onClick={() => setShowInvoice(false)}>
            <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-start' onClick={(e) => e.stopPropagation()}>

              <p className='sec-heading fs-4'>Order Invoice</p>

              <div className='invoice-area my-4'>
                <div className='row justify-content-between'>
                  <p className='col-md-8'><span className='fw-semibold'>Customer Details:</span><br />Name: {selectedProduct.user_name}<br />Mobile No: {selectedProduct.user_phone}<br /> 
                  Delivery Address: {orderAddress}</p>
                  <p className='col-md-4'><span className='fw-semibold'>Order Details:</span><br />Order Id: {selectedProduct.id}<br />Placed On: {formatDate(selectedProduct.order_date)}</p>
                </div>
                {/* flex ends */}
                <hr />

                <div className='table-responsive'>
                  <table className='w-100'>
                    <tr>
                      <th className='px-2 py-2'>Product</th>
                    <th className='px-2 py-2'>MRP ₹</th>
                      <th className='px-2 py-2'>Qty</th>
                    <th className='px-2 py-2'>Discount</th>
                    <th className='px-2 py-2'>Total ₹</th>
                      {/* <th className='px-2 py-2'>Sold By Branch</th> */}
                    </tr>

                    {typeof selectedProduct.order_items === 'string' ? (
                      (() => {
                        try {
                          const parsedItems = JSON.parse(selectedProduct.order_items);
                          if (Array.isArray(parsedItems)) {
                            return parsedItems.map((item, index) => (
                              <tr key={index}>
                                <td className='px-2 py-2'>{item.product_name}</td>
                      <td className='px-2 py-2'>{item.org_price}</td>
                                <td className='px-2 py-2'>{item.quantity}</td>
                      <td className='px-2 py-2'>{item.discount_type == 'amount' ? '₹' : ''} {item.discount_amount} {item.discount_type == 'percent' ? '%' : ''}</td>
                                <td className='px-2 py-2'>{item.product_price * item.quantity}</td>
                              </tr>
                            ));
                          }
                        } catch (error) {
                          return <p>Failed to get items.</p>
                        }
                      })()
                    ) : (
                      <p>No items available.</p>
                    )}

                  </table>
                </div>
                {/* table area */}

                <hr />

{selectedProduct?.order_items && (() => {
  try {
    const items = JSON.parse(selectedProduct.order_items);

    // Sum total price
    const total = items.reduce((sum, item) => sum + Number(item.product_price) * Number(item.quantity), 0);

    return (
      <>
      <p className='text-end my-0 para-text'>
        Order Total: ₹{total.toFixed(2)}<br />
        Platform Fee: ₹{selectedProduct?.platform_fee}<br />
        Delivery Charges: ₹{selectedProduct?.delivery_charge}
      </p>
            <p className='text-end my-0 fw-semibold para-text border-top my-2 py-2 border-bottom'>
              Sub Total: ₹{(Number(total) + Number(selectedProduct?.platform_fee) + Number(selectedProduct?.delivery_charge)).toFixed(2)}
</p>
      </>
    );
  } catch {
    return null;
  }
})()}

{selectedProduct?.coupon_applied && (() => {
  try {
    const coupon = JSON.parse(selectedProduct.coupon_applied);
    return (
      <p className='text-end my-0 para-text border-top my-2 py-2 border-bottom'>
        Coupon Applied: {coupon.coupon_code} <br />
        Discount: {coupon.discount_type === 'percent'
          ? `${coupon.discount_amount}%`
          : `₹${coupon.discount_amount}`}
      </p>
    );
  } catch {
    return null;
  }
})()}
                <p>Grand Total: ₹{selectedProduct.total_amount}<br />Payment Mode: {selectedProduct.payment_mode} <br />Payment Id: {selectedProduct.payment_id || 'NA'} <br />Payment Status: {selectedProduct.payment_status}</p>
                <p>This Order has been {selectedProduct.order_status}.</p>

              </div>
              {/* invoice ends */}
              <button className='danger-btn' onClick={() => setShowInvoice(false)}>Close</button>&nbsp;&nbsp;
              <button className='success-btn' onClick={handlePrint}>Download</button>


            </div>
          </section>
        </>
      )}


      {showExchangeUpdate && selectedExchange && (
  <section className='delete-dialog px-3 py-5'>
    <div
      className='bg-white col-md-8 mx-auto px-4 py-4 rounded-4 text-start'
      onClick={(e) => e.stopPropagation()}
    >
      <p className='sec-heading fs-4'>Update Exchange Status</p>

<div className='d-md-flex justify-content-between'>

<div>
              <p className="para-text fw-semibold text-muted my-0">
              Request Id: {selectedExchange.id}<br />
              Initiated On: {formatDate(selectedExchange.req_on)}<br />
                            Status: {selectedExchange.req_status}
            </p>

            {selectedExchange.remark && (
              <p className="para-text fw-semibold text-danger text-capitalize my-0">
                Remark: {selectedExchange.remark}
              </p>
            )}

                        {selectedExchange.ex_items && (
              <>
                <p className="mt-3 mb-0 para-text fw-bold">Items:</p>
                <ul className="list-unstyled mb-2">
                  {JSON.parse(selectedExchange.ex_items).map((item, i) => (
                    <li key={i} style={{ fontSize: '0.9rem' }}>
                      {item.name} | Qty {item.qty} x ₹{item.price} = ₹{item.total_price}
                    </li>
                  ))}
                </ul>
              </>
            )}

{selectedExchange.attachment && selectedExchange.attachment.trim() !== '' && (
  <>
    <p className="mb-2 para-text fw-bold">Attachments:</p>
    <div className="d-flex flex-wrap gap-2 mb-2">
      {selectedExchange.attachment
        .split(',')
        .map((img, i) => (
          <img
            key={i}
            src={`https://api.kcmstore.in/sUploads/${img.trim()}`}
            alt={`Attachment ${i + 1}`}
            style={{
              width: 80,
              height: 80,
              borderRadius: 5,
              objectFit: 'cover',
            }}
          />
        ))}
    </div>
  </>
)}
</div>

            <div>
            <p className="fw-bold para-text my-0">Customer Details:</p>
            <p className="para-text text-muted">
              Name: {selectedExchange.user_name}<br />
              Mobile No: {selectedExchange.phone}<br />
              Email: {selectedExchange.email}<br />
              Address: {selectedExchange.location} {selectedExchange.city} {selectedExchange.state} {selectedExchange.pincode}
            </p>

          </div>
</div>


      <div className='mb-3'>
        <label className='form-label fw-semibold'>New Status</label>
        <select
          className='form-select'
          value={exchangeStatus}
          onChange={(e) => setExchangeStatus(e.target.value)}
        >
          <option value="">Select status</option>
          <option value="Pending">Pending</option>
          <option value="Exchange Intiated">Exchange Intiated</option>
          <option value="Exchange Shipped">Exchange Shipped</option>
          {/* <option value="Delivered">Delivered</option> */}
                <option value="Cancelled">Cancelled</option>
        </select>
      </div>

      <div className='mb-3'>
        <label className='form-label fw-semibold'>Remark</label>
        <textarea
          className='form-control'
          rows="3"
          placeholder="Add any remarks..."
          value={exchangeRemark}
          onChange={(e) => setExchangeRemark(e.target.value)}
        />
      </div>

      <div className='d-flex justify-content-center'>
        <button className='success-btn me-2' onClick={handleExchangeUpdate}>Update</button>
        <button className='danger-btn' onClick={() => setShowExchangeUpdate(false)}>Cancel</button>
      </div>
    </div>
  </section>
)}
 

       {showStore && (
        <>
          <section className='delete-dialog px-3'>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-4 rounded-4 '>
              <p className='featured-category my-4'>Allot Order to Sub Store</p>

              <select
                id="order-status"
                className="form-select mb-4"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}>
                <option value="">Select Store</option>
                {loading ? (
                  <option>Loading...</option>
                ) : (
                  // Map over the unique categories
                  store.map((store, index) => (
                    <option key={index} value={store.id}>
                      {store.name} ({store.city}, {store.state})
                    </option>
                  ))
                )}
              </select>

                      <label className='form-label fw-semibold'>Remark</label>
        <textarea
          className='form-control mb-3'
          rows="3"
          placeholder="Add any remarks..."
          value={exchangeRemark}
          onChange={(e) => setExchangeRemark(e.target.value)}
        />

              <button className='success-btn' onClick={() => handleAssignStore(selectedProduct.id, exchangeRemark, newStatus)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowStore(false)}>No</button>
            </div>
          </section>
        </>
      )}

{loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default ManageOrders
